import { render, staticRenderFns } from "./DownloadAll.vue?vue&type=template&id=54609a28&scoped=true&"
import script from "./DownloadAll.vue?vue&type=script&lang=js&"
export * from "./DownloadAll.vue?vue&type=script&lang=js&"
import style0 from "./DownloadAll.vue?vue&type=style&index=0&id=54609a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54609a28",
  null
  
)

export default component.exports